import React, { useState, useEffect } from 'react';

import Icon from '../../../components/AppIcon';

const ServiceCategoriesSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [activeTab, setActiveTab] = useState('implementation');

  const translations = {
    en: {
      title: "Our Service Categories",
      subtitle: "Comprehensive ERP services tailored for aluminum extrusion manufacturers",
      tabs: {
        implementation: "Implementation",
        training: "Training",
        support: "Support",
        consulting: "Consulting"
      }
    },
    hi: {
      title: "हमारी सेवा श्रेणियां",
      subtitle: "एल्यूमीनियम एक्सट्रूज़न निर्माताओं के लिए अनुकूलित व्यापक ERP सेवाएं",
      tabs: {
        implementation: "कार्यान्वयन",
        training: "प्रशिक्षण",
        support: "सहायता",
        consulting: "परामर्श"
      }
    }
  };

  const t = translations[currentLanguage];

  const serviceCategories = {
    implementation: {
      title: currentLanguage === 'en' ? 'ERP Implementation' : 'ERP कार्यान्वयन',
      description: currentLanguage === 'en' ?'Complete end-to-end implementation with customization for aluminum extrusion processes' :'एल्यूमीनियम एक्सट्रूज़न प्रक्रियाओं के लिए अनुकूलन के साथ संपूर्ण अंत-से-अंत कार्यान्वयन',
      services: [
        {
          title: currentLanguage === 'en' ? 'System Assessment' : 'सिस्टम मूल्यांकन',
          description: currentLanguage === 'en' ?'Comprehensive analysis of existing processes and requirements' :'मौजूदा प्रक्रियाओं और आवश्यकताओं का व्यापक विश्लेषण',
          duration: currentLanguage === 'en' ? '2-3 weeks' : '2-3 सप्ताह',
          price: '₹1,50,000 - ₹2,50,000',
          icon: 'Search'
        },
        {
          title: currentLanguage === 'en' ? 'Custom Development' : 'कस्टम विकास',
          description: currentLanguage === 'en' ?'Tailored modules for aluminum-specific manufacturing processes' :'एल्यूमीनियम-विशिष्ट निर्माण प्रक्रियाओं के लिए अनुकूलित मॉड्यूल',
          duration: currentLanguage === 'en' ? '8-12 weeks' : '8-12 सप्ताह',
          price: '₹5,00,000 - ₹15,00,000',
          icon: 'Code'
        },
        {
          title: currentLanguage === 'en' ? 'Data Migration' : 'डेटा माइग्रेशन',
          description: currentLanguage === 'en' ?'Secure transfer of existing data with validation and cleanup' :'सत्यापन और सफाई के साथ मौजूदा डेटा का सुरक्षित स्थानांतरण',
          duration: currentLanguage === 'en' ? '3-4 weeks' : '3-4 सप्ताह',
          price: '₹2,00,000 - ₹5,00,000',
          icon: 'Database'
        }
      ]
    },
    training: {
      title: currentLanguage === 'en' ? 'Training Programs' : 'प्रशिक्षण कार्यक्रम',
      description: currentLanguage === 'en' ?'Comprehensive training programs for different user roles and skill levels' :'विभिन्न उपयोगकर्ता भूमिकाओं और कौशल स्तरों के लिए व्यापक प्रशिक्षण कार्यक्रम',
      services: [
        {
          title: currentLanguage === 'en' ? 'Administrator Training' : 'प्रशासक प्रशिक्षण',
          description: currentLanguage === 'en' ?'Advanced training for system administrators and IT staff' :'सिस्टम प्रशासकों और IT कर्मचारियों के लिए उन्नत प्रशिक्षण',
          duration: currentLanguage === 'en' ? '40 hours' : '40 घंटे',
          price: '₹80,000 - ₹1,20,000',
          icon: 'Settings'
        },
        {
          title: currentLanguage === 'en' ? 'End-User Training' : 'अंतिम उपयोगकर्ता प्रशिक्षण',
          description: currentLanguage === 'en' ?'Role-based training for production and office staff' :'उत्पादन और कार्यालय कर्मचारियों के लिए भूमिका-आधारित प्रशिक्षण',
          duration: currentLanguage === 'en' ? '24 hours' : '24 घंटे',
          price: '₹50,000 - ₹80,000',
          icon: 'Users'
        },
        {
          title: currentLanguage === 'en' ? 'Certification Program' : 'प्रमाणन कार्यक्रम',
          description: currentLanguage === 'en' ?'Official certification with continuous assessment' :'निरंतर मूल्यांकन के साथ आधिकारिक प्रमाणन',
          duration: currentLanguage === 'en' ? '60 hours' : '60 घंटे',
          price: '₹1,00,000 - ₹1,50,000',
          icon: 'Award'
        }
      ]
    },
    support: {
      title: currentLanguage === 'en' ? 'Support Services' : 'सहायता सेवाएं',
      description: currentLanguage === 'en' ?'24/7 technical support with guaranteed response times and dedicated account management' :'गारंटीशुदा प्रतिक्रिया समय और समर्पित खाता प्रबंधन के साथ 24/7 तकनीकी सहायता',
      services: [
        {
          title: currentLanguage === 'en' ? 'Priority Support' : 'प्राथमिकता सहायता',
          description: currentLanguage === 'en' ?'Immediate response for critical issues with dedicated hotline' :'समर्पित हॉटलाइन के साथ महत्वपूर्ण मुद्दों के लिए तत्काल प्रतिक्रिया',
          duration: currentLanguage === 'en' ? '24/7 availability' : '24/7 उपलब्धता',
          price: '₹2,00,000 - ₹3,00,000/year',
          icon: 'Phone'
        },
        {
          title: currentLanguage === 'en' ? 'Remote Assistance' : 'रिमोट सहायता',
          description: currentLanguage === 'en' ?'Screen sharing and remote troubleshooting capabilities' :'स्क्रीन शेयरिंग और रिमोट समस्या निवारण क्षमताएं',
          duration: currentLanguage === 'en' ? 'On-demand' : 'मांग पर',
          price: '₹1,00,000 - ₹2,00,000/year',
          icon: 'Monitor'
        },
        {
          title: currentLanguage === 'en' ? 'Maintenance & Updates' : 'रखरखाव और अपडेट',
          description: currentLanguage === 'en' ?'Regular system updates and preventive maintenance' :'नियमित सिस्टम अपडेट और निवारक रखरखाव',
          duration: currentLanguage === 'en' ? 'Monthly' : 'मासिक',
          price: '₹50,000 - ₹1,00,000/year',
          icon: 'Wrench'
        }
      ]
    },
    consulting: {
      title: currentLanguage === 'en' ? 'Consulting Services' : 'परामर्श सेवाएं',
      description: currentLanguage === 'en' ?'Strategic consulting for process optimization and digital transformation' :'प्रक्रिया अनुकूलन और डिजिटल परिवर्तन के लिए रणनीतिक परामर्श',
      services: [
        {
          title: currentLanguage === 'en' ? 'Process Optimization' : 'प्रक्रिया अनुकूलन',
          description: currentLanguage === 'en' ?'Analyze and optimize manufacturing processes for efficiency' :'दक्षता के लिए निर्माण प्रक्रियाओं का विश्लेषण और अनुकूलन',
          duration: currentLanguage === 'en' ? '6-8 weeks' : '6-8 सप्ताह',
          price: '₹3,00,000 - ₹5,00,000',
          icon: 'TrendingUp'
        },
        {
          title: currentLanguage === 'en' ? 'Compliance Advisory' : 'अनुपालन सलाहकार',
          description: currentLanguage === 'en' ?'Ensure regulatory compliance and quality standards' :'नियामक अनुपालन और गुणवत्ता मानकों को सुनिश्चित करना',
          duration: currentLanguage === 'en' ? '4-6 weeks' : '4-6 सप्ताह',
          price: '₹2,00,000 - ₹4,00,000',
          icon: 'Shield'
        },
        {
          title: currentLanguage === 'en' ? 'Digital Transformation' : 'डिजिटल परिवर्तन',
          description: currentLanguage === 'en' ?'Strategic roadmap for complete digital transformation' :'पूर्ण डिजिटल परिवर्तन के लिए रणनीतिक रोडमैप',
          duration: currentLanguage === 'en' ? '8-12 weeks' : '8-12 सप्ताह',
          price: '₹5,00,000 - ₹10,00,000',
          icon: 'Zap'
        }
      ]
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  return (
    <section id="service-categories" className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Service Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {Object.keys(serviceCategories).map((category) => (
            <button
              key={category}
              onClick={() => setActiveTab(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                activeTab === category
                  ? 'bg-primary text-white shadow-lg'
                  : 'bg-surface-100 text-text-secondary hover:bg-surface-200'
              }`}
            >
              {t.tabs[category]}
            </button>
          ))}
        </div>

        {/* Active Service Category */}
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-border">
          <div className="mb-8">
            <h3 className="text-2xl font-bold text-primary mb-4">
              {serviceCategories[activeTab].title}
            </h3>
            <p className="text-text-secondary text-lg">
              {serviceCategories[activeTab].description}
            </p>
          </div>

          {/* Service Cards */}
          <div className="grid md:grid-cols-3 gap-6">
            {serviceCategories[activeTab].services.map((service, index) => (
              <div
                key={index}
                className="bg-surface-50 rounded-xl p-6 border border-border hover:shadow-md transition-shadow duration-300"
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-primary-100 p-3 rounded-lg">
                    <Icon name={service.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-primary mb-2">{service.title}</h4>
                    <p className="text-text-secondary text-sm mb-4">{service.description}</p>
                    
                    <div className="space-y-2">
                      <div className="flex items-center text-sm">
                        <Icon name="Clock" size={14} color="var(--color-text-secondary)" />
                        <span className="ml-2 text-text-secondary">{service.duration}</span>
                      </div>
                      <div className="flex items-center text-sm">
                        <Icon name="DollarSign" size={14} color="var(--color-success)" />
                        <span className="ml-2 text-success font-medium">{service.price}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCategoriesSection;